import React from "react";
import {
    Grid,
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    tableCellClasses,
    CircularProgress,
    Paper,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tooltip,
    InputAdornment,
    Divider,
} from "@mui/material";
import { SearchIcon } from 'assets';
import Pagination from "components/Pagination";
import Colors from "assets/Style/Colors";
import { makeStyles } from "@mui/styles";
import { FontFamily } from "assets";
import { PrimaryButton } from "components/Buttons";
import { useState, Fragment, useEffect } from "react";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import InputField from "components/Input";
import { Upload } from "@mui/icons-material";

import UploadFile from "components/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "context/UseContext";
import * as pdfjsLib from 'pdfjs-dist';
import VccServices from "services/Vcc";
import { startVccBotAgent } from "utils/lambda";
import { startDeclarationBotAgent } from "utils/lambda";
import { Add, Remove } from "@mui/icons-material";


pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';


// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
    border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        border: 0,
        padding: "15px",
        textAlign: "center",
        whiteSpace: "nowrap",
        background: Colors.primary,
        color: Colors.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        textAlign: "center",
        textWrap: "nowrap",

        padding: "5px !important",
        ".MuiBox-root": {
            display: "flex",
            gap: "6px",
            alignItems: "center",
            justifyContent: "center",
            ".MuiBox-root": {
                cursor: "pointer",
            },
        },
        svg: {
            width: "auto",
            height: "24px",
        },
        ".MuiTypography-root": {
            textTransform: "capitalize",
            fontFamily: FontFamily.NunitoRegular,
            textWrap: "nowrap",
        },
        ".MuiButtonBase-root": {
            padding: "8px",
            width: "28px",
            height: "28px",
        },

        '.truncate-text': {
            display: 'inline-block',
            maxWidth: '200px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
}));


const useStyles = makeStyles({
    loaderWrap: {
        display: "flex",
        height: 100,
        "& svg": {
            width: "40px !important",
            height: "40px !important",
        },
    },
});

function UploadDeclaration() {
    const [loading, setLoading] = useState(false);
    const [loadings, setLoadings] = useState(false);
    const classes = useStyles();
    const navigate = useNavigate();
    const [isSearching, setIsSearching] = useState(false);

    const { user } = useAuth();

    const {
        register,
        handleSubmit,
        getValues: getValues1,
        setValue,
        formState: { errors },
        watch,
    } = useForm();

    const tableHead = [
        "Sr.No",
        "Uploaded Date",
        "Declaration/Vcc No",
        "Declaration Date",
        "Container No",
        "VIN",
        "Bot Status",
        "Remarks",
    ];

    const tableHeadVcc = [
        "Sr.No",
        "VCC No",
        "VIN",
        "Bot Status",
        "Remarks",
    ];


    const [loader, setLoader] = useState(false);
    const [loaders, setLoaders] = useState(false);

    const [declarationUploadDialog, setDeclarationUploadDialog] = useState(false);
    const [vccUploadDialog, setVccUploadDialog] = useState(false);
    const [declarationUploadViewDialog, setDeclarationUploadViewDialog] = useState(false);

    const [pdfData, setPdfData] = useState([]);
    const [pdfDataVcc, setPdfDataVcc] = useState([]);

    const [uploadedFileName, setUploadedFileName] = useState("");
    const [file, setFile] = useState(null);
    const [files, setFiles] = useState(null);
    const [progress2, setProgress2] = useState(0);
    const [uploadedSize2, setUploadedSize2] = useState(0);
    const [documentDetail2, setDocumentDetail2] = useState([]);
    const [documentLink2, setDocumentLink2] = useState('');
    const allowDeclarationFilesType = ['application/pdf']
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedFilesVcc, setSelectedFilesVcc] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [pageLimit, setPageLimit] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);

    const [totalCount2, setTotalCount2] = useState(0);
    const [pageLimit2, setPageLimit2] = useState(20);
    const [currentPage2, setCurrentPage2] = useState(1);
    const [isSearchingVcc, setIsSearchingVcc] = useState(false);
    const [filters, setFilters] = useState({});
    const [filters2, setFilters2] = useState({});
    const [expandedRows, setExpandedRows] = useState([]);
    const [childData, setChildData] = useState(null);


    const toggleRow = (id, item) => {
        setExpandedRows((prevState) => (prevState === id ? null : id));
        setChildData(item);
    };


    const downloadAllAttachments = async (documentLinks) => {

        if (!documentLinks || documentLinks.trim() === "") {
            ErrorToaster("No attachments available.");
            return;
        }

        const filePath = documentLinks.trim();
        const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
        const fileExtension = filePath.split('.').pop();

        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", `attachment.${fileExtension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl); // Cleanup
            SuccessToaster("Downloading attachment...");
        } catch (error) {
            console.error("Download failed", error);
            ErrorToaster("Failed to download attachment.");
        }
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const fileNames = files.map(file => file.name);
        setFile(fileNames.join(', '));
        setSelectedFiles(files);
        // SuccessToaster("files uploaded")

    };

    const handleFileChangeVcc = (e) => {
        const files = Array.from(e.target.files);
        const fileNames = files.map(file => file.name);
        setFiles(fileNames.join(', '));
        setSelectedFilesVcc(files);
        // SuccessToaster("files uploaded")

    };


    async function convertFileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result.split(",")[1];
                resolve({
                    name: file.name,
                    mimetype: file.type || "application/pdf",
                    base64: base64String,
                });
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    }


    const handleUploadVcc = async () => {
        if (selectedFilesVcc.length === 0) {
            console.log("No files selected");
            return;
        }
        setLoadings(true);

        try {
            const fileDataArray = await Promise.all(
                selectedFilesVcc.map((file) => convertFileToBase64(file))
            );

            const payload = {
                table: "vcc-upload",
                files: fileDataArray,
            };


            await startVccBotAgent(payload);

            setVccUploadDialog(false);
            getVccData();
        } catch (error) {
            console.error("Error uploading files:", error);
        } finally {
            setLoadings(false)
        }
    };

    const handleUpload = async () => {
        if (selectedFiles.length === 0) {
            console.log("No files selected");
            return;
        }

        setLoading(true);

        try {
            const fileDataArray = await Promise.all(
                selectedFiles.map((file) => convertFileToBase64(file))
            );

            const payload = {
                table: "declration-upload",
                files: fileDataArray,
            };


            await startDeclarationBotAgent(payload);

            setDeclarationUploadDialog(false);
            getDeclarationData();

        } catch (error) {
            console.error("Error uploading files:", error);
        } finally {
            setLoading(false)
        }
    };


    const DATE_RE = /\b([0-3]?\d)[\/\-.]([01]?\d)[\/\-.](\d{2}|\d{4})\b(?![A-Za-z])/g;
    const DEC_NO_RE = /\b\d{3}-\d{8}-\d{2}\b/;

    const findDateBeforeOrNearest = (text, anchorStr) => {
        const anchorMatch = text.match(anchorStr instanceof RegExp ? anchorStr : new RegExp(anchorStr));
        if (!anchorMatch) return '';

        const anchorIdx = text.indexOf(anchorMatch[0]);

        const dates = [];
        DATE_RE.lastIndex = 0;
        let m;
        while ((m = DATE_RE.exec(text)) !== null) {
            dates.push({ raw: m[0], idx: m.index });
        }
        if (!dates.length) return '';

        const before = dates.filter(d => d.idx <= anchorIdx);
        if (before.length) {
            before.sort((a, b) => b.idx - a.idx);
            return before[0].raw;
        }

        const after = dates.filter(d => d.idx > anchorIdx);
        after.sort((a, b) => a.idx - b.idx);
        return after[0]?.raw || '';
    };


    const extractText = (text) => {
        const t = text.replace(/\s+/g, ' ').trim();

        const decNo = (t.match(/\b\d{3}-\d{8}-\d{2}\b/) || [])[0] || '';

        const decDate = decNo ? findDateBeforeOrNearest(t, decNo) : '';

        const containersChunk = (t.match(/\bContainer\s*Nos\s*[:\-]?\s*([A-Z0-9,\/\-\s]+)/i) || [])[1] || '';


        const containerNos = [];
        const containerTokenRegex = /\b(?=[A-Za-z0-9]*[A-Za-z])(?=[A-Za-z0-9]*\d)[A-Za-z0-9]+\b/g;

        let m;
        while ((m = containerTokenRegex.exec(containersChunk)) !== null) {
            containerNos.push(m[0].toUpperCase());
        }


        const usedVehiclesRegex = /\bUSED\s[A-Za-z]+\s(\d{3})\b/g;
        const usedVehicles = [];
        let match;

        while ((match = usedVehiclesRegex.exec(t)) !== null) {
            usedVehicles.push(match[1]);
        }

        const insValuesRegex = /(\d+\.\d{2}|\d+)\s+INS(?!\s*[:])/g;

        const insValues = [];
        let insMatch;

        while ((insMatch = insValuesRegex.exec(t)) !== null) {
            insValues.push(insMatch[1]);
        }


        return {
            decNo,
            decDate,
            containerNos,
            usedVehicles,
            insValues,
        };
    };


    const extractTextWithPosition = (content) => {
        const sortedItems = content.items.sort((a, b) => {
            if (a.transform[5] === b.transform[5]) {
                return a.transform[4] - b.transform[4];
            }
            return a.transform[5] - b.transform[5];
        });

        let pageText = "";
        sortedItems.forEach(item => {
            pageText += item.str + " ";
        });

        return pageText.trim();
    };


    const extractPdfData = async (arrayBuffer, fileName) => {
        try {
            const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
            const numPages = pdf.numPages;

            let extractedData = [];
            let allUsedVehicles = new Set();
            let allInsValues = new Set();

            for (let pageNum = 1; pageNum <= numPages; pageNum++) {
                const page = await pdf.getPage(pageNum);
                const content = await page.getTextContent();
                // const pageText = content.items.map(item => item.str).join(' ');
                const pageText = extractTextWithPosition(content);


                const pageData = extractText(pageText);

                pageData.fileName = fileName;

                pageData.usedVehicles.forEach(vehicle => allUsedVehicles.add(vehicle));
                pageData.insValues.forEach(vehicle => allInsValues.add(vehicle));

                const isDuplicate = extractedData.some((data) =>
                    data.decNo === pageData.decNo ||
                    data.decDate === pageData.decDate ||
                    data.containerNos.join(',') === pageData.containerNos.join(',')
                );

                if (!isDuplicate) {
                    extractedData.push(pageData);
                }
            }

            extractedData.forEach((data) => {
                data.usedVehicles = [...allUsedVehicles];
            });


            extractedData.forEach((data) => {
                data.insValues = [...allInsValues];
            });



            return extractedData;
        } catch (error) {
            console.error('Error extracting PDF data:', error);
            return [];
        }
    };


    const handleFileUpload = async (e) => {
        // const file = e.target.files[0]; 
        const files = e.target.files;


        if (files.length === 0) return;

        // if (!file) return; 

        let allExtractedData = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            const arrayBuffer = await file.arrayBuffer();

            const extractedData = await extractPdfData(arrayBuffer, file.name);

            allExtractedData = [...allExtractedData, ...extractedData];
        }
        // const arrayBuffer = await file.arrayBuffer();

        // const extractedData = await extractPdfData(arrayBuffer, file.name);

        // setPdfData(extractedData);
        setPdfData(allExtractedData);
        setDeclarationUploadDialog(false);
        // setDeclarationUploadViewDialog(true);
    };
    const handleCloseUploadDialog = () => {
        setDeclarationUploadDialog(false);
        setFile(null);
        setUploadedFileName("");
    };

    const handleCloseUploadVccDialog = () => {
        setVccUploadDialog(false);
        setFile(null);
        setUploadedFileName("");
    };

    const handleCloseUploadViewDialog = () => {
        setDeclarationUploadViewDialog(false);

    };


    const getDeclarationData = async (page, limit, filter) => {
        setLoader(true);
        try {
            const Page = page ? page : currentPage
            const Limit = limit ? limit : pageLimit
            const Filter = { ...filters, ...filter };

            setCurrentPage(Page)
            setPageLimit(Limit)
            setFilters(Filter);

            let params = {
                page: Page,
                limit: Limit
            }

            params = { ...params, ...Filter };

            const { data } = await VccServices.getAiDeclaration(params)
            setPdfData(data?.declaration?.rows);
            setTotalCount(data?.declaration?.count);
        } catch (error) {
            ErrorToaster(error)
        } finally {
            setLoader(false);
        }
    }

    const getVccData = async (page, limit, filter) => {
        setLoaders(true);
        try {
            const Page = page ? page : currentPage
            const Limit = limit ? limit : pageLimit2
            const Filter = { ...filters, ...filter };

            setCurrentPage2(Page)
            setPageLimit2(Limit)
            setFilters2(Filter);

            let params = {
                page: Page,
                limit: Limit
            }
            params = { ...params, ...Filter };

            const { data } = await VccServices.getAiVcc(params)
            setPdfDataVcc(data?.vccs?.rows);
            setTotalCount2(data?.vccs?.count);
        } catch (error) {
            ErrorToaster(error)
        } finally {
            setLoaders(false);
        }
    }

    useEffect(() => {
        getDeclarationData();
        getVccData();
    }, [])


    // const handleFilter = async (data) => {
    //     if (!data) {
    //         return;
    //     }

    //     if (isSearching) return;
    //     setIsSearching(true);
    //     try {
    //         await getDeclarationData(1, "", data);

    //     } catch (err) {
    //         console.error("Search failed:", err);
    //     } finally {
    //         setIsSearching(false);
    //     }
    // }

    const handleFilter = async (data) => {
        if (isSearching) return;

        setIsSearching(true);

        try {
            if (!data.search || data.search.trim() === "") {
                await getDeclarationData(1, pageLimit, {});
            } else {
                await getDeclarationData(1, pageLimit, data);
            }
        } catch (err) {
            console.error("Search failed:", err);
        } finally {
            setIsSearching(false);
        }
    };


    const handleSearchChange = async (e) => {
        const searchValue = e.target.value;

        if (searchValue === "") {
            await getDeclarationData(1, pageLimit, "");
        }
    };


    const handleSearchChangeVcc = async (e) => {
        const searchValue = e.target.value;

        if (searchValue === "") {
            await getVccData(1, pageLimit2, "");
        }
    };


    const handleFilterVcc = async (data) => {
        if (!data) {
            return;
        }

        if (isSearchingVcc) return;
        setIsSearchingVcc(true);
        try {
            if (!data.search || data.search.trim() === "") {
                await getVccData(1, pageLimit, {});
            } else {
                await getVccData(1, "", data);

            }

        } catch (err) {
            console.error("Search failed:", err);
        } finally {
            setIsSearchingVcc(false);
        }
    }



    const pdf = pdfData?.vccDetails?.map(detail => detail.vin).join(", ")


    return (
        <>

            <Dialog
                open={declarationUploadDialog}
                onClose={handleCloseUploadDialog}
                PaperProps={{ sx: { p: 2, width: "500px", borderRadius: "14px" } }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <span>Upload Declaration</span>
                    <IconButton onClick={handleCloseUploadDialog} sx={{ padding: 0 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>


                    <Typography variant="body1" sx={{ mb: 1 }}>
                        Attach File
                    </Typography>
                    <UploadFile
                        custom={true}
                        vendor={true}
                        multiple={true}
                        style={{
                            backgroundColor: "#e7efeb",
                            width: "100%",
                            height: "40px",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "30px",
                            border: "1px dashed #aeb1b0",
                            borderRadius: "10px",
                        }}
                        error={errors?.scanned?.message}
                        register={register("scanned", {
                            onChange: (e) => handleFileChange(e),
                            // onChange: (e) => {
                            //   const selectedFiles = e.target.files;
                            //   const fileNames = Array.from(selectedFiles).map(file => file.name);

                            //   setFile(selectedFiles);
                            //   setUploadedFileName(fileNames.join(", "));
                            //   // const selectedFile = e.target.files[0];
                            //   // setFile(selectedFile);
                            //   // setUploadedFileName(selectedFile ? selectedFile.name : "");
                            // },
                        })}
                    />

                    {file && (
                        <Typography
                            variant="body2"
                            sx={{ marginTop: "10px", color: "#333" }}
                        >
                            <strong>Uploaded Files: </strong>
                            {file}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <PrimaryButton title={"Upload"}
                        onClick={handleUpload}
                        disabled={selectedFiles.length === 0}
                        loading={loading} />
                </DialogActions>
            </Dialog>


            <Dialog
                open={vccUploadDialog}
                onClose={handleCloseUploadDialog}
                PaperProps={{ sx: { p: 2, width: "500px", borderRadius: "14px" } }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <span>Upload VCC</span>
                    <IconButton onClick={handleCloseUploadVccDialog} sx={{ padding: 0 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>


                    <Typography variant="body1" sx={{ mb: 1 }}>
                        Attach File
                    </Typography>
                    <UploadFile
                        custom={true}
                        vendor={true}
                        multiple={true}
                        style={{
                            backgroundColor: "#e7efeb",
                            width: "100%",
                            height: "40px",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "30px",
                            border: "1px dashed #aeb1b0",
                            borderRadius: "10px",
                        }}
                        error={errors?.scanned?.message}
                        register={register("scanned", {
                            onChange: (e) =>
                                handleFileChangeVcc(e)
                            // handleFileUpload(e),

                        })}
                    />
                    {files && (
                        <Typography
                            variant="body2"
                            sx={{ marginTop: "10px", color: "#333" }}
                        >
                            <strong>Uploaded Files: </strong>
                            {files}
                        </Typography>
                    )}

                </DialogContent>
                <DialogActions>
                    <PrimaryButton title={"Upload"}
                        onClick={handleUploadVcc}
                        disabled={selectedFilesVcc.length === 0}
                        loading={loadings}
                    />
                </DialogActions>
            </Dialog>

            <Box component={"form"}>
                <Box sx={{ width: "100%" }} mt={3}>
                    <Grid container>
                        <Grid item md={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    my: 2,
                                    ml: 4,
                                    mr: 8,
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        color: Colors.charcoalGrey,
                                        fontFamily: FontFamily.NunitoRegular,
                                        textAlign: "left",
                                    }}
                                >
                                    Declaration Attachments
                                </Typography>

                            </Box>
                        </Grid>

                    </Grid>
                </Box>

                <Grid item md={11}>
                    <Box
                        sx={{
                            m: '10px 0 10px 0',
                            p: '10px',
                            //    bgcolor: Colors.feta,
                            //    border: `1px solid ${Colors.iron}`,
                            //    borderRadius: '9px',
                        }}
                    >
                        <Grid
                            container
                            spacing={2}
                            alignItems={'center'}
                            component={'form'}
                        >
                            <Grid item xs={12} sm={4} ml={2.5} sx={{ marginTop: "5px" }}>
                                <InputField
                                    size={"small"}
                                    inputStyle={{ backgroundColor: "#f5f5f5" }}
                                    label={"Search"}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    placeholder={"Search"}
                                    register={register("search", {
                                        onChange: (e) => handleSearchChange(e),
                                    })}

                                />
                            </Grid>

                            <Grid item xs={12} sm={7.4} md={7.4} sx={{ display: "flex", justifyContent: "space-between", marginTop: "18px" }}>



                                <PrimaryButton
                                    onClick={() => {
                                        const searchValue = getValues1("search");
                                        if (searchValue) {
                                            handleFilter({ search: searchValue });
                                        }
                                    }}
                                    title="Search" />


                                <PrimaryButton
                                    title="Upload Declaration"
                                    type="button"
                                    style={{ backgroundColor: Colors.bluishCyan }}
                                    startIcon={<Upload sx={{ color: Colors.white }} />}
                                    onClick={() => setDeclarationUploadDialog(true)}

                                />


                            </Grid>



                        </Grid>
                    </Box>
                </Grid>


                <Box sx={{ m: 4, mb: 3 }}>
                    <Fragment>

                        <TableContainer
                            component={Paper}
                            sx={{
                                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                borderRadius: 2,
                                maxHeight: "calc(100vh - 330px)",

                            }}
                            className="table-box"
                        >
                            <Table stickyHeader sx={{ minWidth: 500 }}>
                                <TableHead>
                                    <TableRow>
                                        {tableHead.map((item, index) => (
                                            <Cell className="pdf-table" key={index}>
                                                {item}
                                            </Cell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!loader ? (
                                        pdfData.length > 0 ? (
                                            <Fragment>
                                                {pdfData.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <Row
                                                                sx={{ bgcolor: index % 2 !== 0 && "#EFF8E7" }}
                                                            >
                                                                <Cell className="pdf-table">
                                                                    {item?.id && (
                                                                        <IconButton
                                                                            sx={{
                                                                                p: "4px",
                                                                                ml: 1,
                                                                                color: "green",
                                                                            }}
                                                                            onClick={() => toggleRow(item?.id, item)}
                                                                        >
                                                                            {expandedRows === item?.id ? <Remove /> : <Add />}
                                                                        </IconButton>
                                                                    )}
                                                                    {index + 1 ?? "-"}
                                                                </Cell>
                                                                 <Cell className="pdf-table">
                                                                    {moment(item?.created_at).format("DD-MMM-YYYY") ?? "-"}
                                                                </Cell>
                                                                <Cell className="pdf-table" onClick={() => downloadAllAttachments(item?.dec_document_url)} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                                                                    {item?.declaration_number ?? "-"}
                                                                </Cell>

                                                                <Cell className="pdf-table">
                                                                    {moment(item?.declaration_date).format("DD-MMM-YYYY") ?? "-"}
                                                                </Cell>
                                                                <Cell className="pdf-table">
                                                                    <Tooltip title={item?.container_number.join(', ') ?? "-"}>
                                                                        <Box className="truncate-text">
                                                                            {item?.container_number?.length > 15
                                                                                ? item?.container_number.join(', ').slice(0, 20) + "..."
                                                                                : item?.container_number.join(', ')}
                                                                        </Box>
                                                                    </Tooltip>
                                                                </Cell>
                                                                <Cell className="pdf-table">
                                                                    <Tooltip title={item?.vccDetails?.map(detail => detail.vin).join(", ") ?? "-"} arrow>
                                                                        <Box className="truncate-text">
                                                                            {item?.vccDetails?.map(detail => detail.vin).join(", ").length > 20
                                                                                ? item?.vccDetails?.map(detail => detail.vin).join(", ").slice(0, 20) + "..."
                                                                                : item?.vccDetails?.map(detail => detail.vin).join(", ")}
                                                                        </Box>
                                                                    </Tooltip>
                                                                </Cell>
                                                                <Cell>{"-"}</Cell>
                                                                <Cell>{item?.status === 'uploaded' ? 'Document Uploaded' : item?.status }</Cell>
                                                            </Row>

                                                            {/* Render expanded rows */}
                                                            {expandedRows === item?.id && (
                                                                <Fragment>
                                                                    {item?.vccDetails.map((detail, detailIndex) => (
                                                                        <Row
                                                                            key={detailIndex}
                                                                            sx={{
                                                                                bgcolor: detailIndex % 2 !== 0 ? "#EFF8E7" : undefined,
                                                                            }}
                                                                        >
                                                                            <Cell>{detailIndex + 1}</Cell>
                                                                            <Cell></Cell>
                                                                            <Cell></Cell>
                                                                            <Cell>{detail?.container_no ?? "-"}</Cell>
                                                                            <Cell>{detail?.vin ?? "-"}</Cell>
                                                                            <Cell>Bot {detail?.bot_number} Task 1 - {detail?.is_completed === true ? "Completed" : "Pending"}</Cell>
                                                                            <Cell>{detail?.is_completed === true ? "Completed" : "Pending"}</Cell>
                                                                            <Cell>{detail?.comments ?? "-"}</Cell>

                                                                        </Row>
                                                                    ))}
                                                                </Fragment>
                                                            )}
                                                        </Fragment>
                                                    );
                                                })}
                                            </Fragment>
                                        ) : (
                                            <Row>
                                                <Cell
                                                    colSpan={tableHead?.length + 1}
                                                    align="center"
                                                    sx={{ fontWeight: 600 }}
                                                >
                                                    No Data Found
                                                </Cell>
                                            </Row>
                                        )
                                    ) : (
                                        <Row>
                                            <Cell
                                                colSpan={tableHead?.length + 2}
                                                align="center"
                                                sx={{ fontWeight: 600 }}
                                            >
                                                <Box className={classes.loaderWrap}>
                                                    <CircularProgress />
                                                </Box>
                                            </Cell>
                                        </Row>
                                    )}
                                </TableBody>


                            </Table>
                        </TableContainer>


                        <Pagination
                            currentPage={currentPage}
                            pageSize={pageLimit}
                            onPageSizeChange={(size) =>
                                getDeclarationData(1, size.target.value)
                            }
                            tableCount={pdfData?.length}
                            totalCount={totalCount}
                            onPageChange={(page) => getDeclarationData(page, "")}
                        />
                    </Fragment>
                </Box>

                <Divider sx={{ my: 6, ml: 4.5, mr: 4.5 }} />


                <Box sx={{ width: "100%" }} mt={3}>
                    <Grid container>
                        <Grid item md={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 2,
                                    ml: 4,
                                    mr: 8,
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        color: Colors.charcoalGrey,
                                        fontFamily: FontFamily.NunitoRegular,
                                        textAlign: "left",
                                    }}
                                >
                                    VCC Attachments
                                </Typography>
                            </Box>
                        </Grid>

                    </Grid>
                </Box>

                <Grid item md={11}>
                    <Box
                        sx={{
                            m: '10px 0 10px 0',
                            p: '10px',
                            //    bgcolor: Colors.feta,
                            //    border: `1px solid ${Colors.iron}`,
                            //    borderRadius: '9px',
                        }}
                    >
                        <Grid
                            container
                            spacing={2}
                            alignItems={'center'}
                            component={'form'}
                        >
                            <Grid item xs={12} sm={4} md={4} ml={2.5} sx={{ marginTop: "5px" }}>
                                <InputField
                                    size={"small"}
                                    inputStyle={{ backgroundColor: "#f5f5f5" }}
                                    label={"Search"}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    placeholder={"Search"}
                                    register={register("searchVcc", {
                                        onChange: (e) => handleSearchChangeVcc(e),
                                    })}
                                />
                            </Grid>

                            <Grid item xs={12} sm={7.4} md={7.4} sx={{ display: "flex", justifyContent: "space-between", marginTop: "18px" }}>
                                <PrimaryButton
                                    onClick={() => {
                                        const searchVal = getValues1("searchVcc");
                                        if (searchVal) {
                                            handleFilterVcc({ search: searchVal });
                                        }
                                    }}
                                    title="Search"
                                />

                                <PrimaryButton
                                    title="Upload Vcc"
                                    type="button"
                                    style={{ backgroundColor: Colors.bluishCyan }}
                                    startIcon={<Upload sx={{ color: Colors.white }} />}
                                    onClick={() => setVccUploadDialog(true)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>




                <Box sx={{ m: 4, mb: 3 }}>
                    <Fragment>

                        <TableContainer
                            component={Paper}
                            sx={{
                                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                borderRadius: 2,
                                maxHeight: "calc(100vh - 330px)",
                            }}
                            className="table-box"
                        >
                            <Table stickyHeader sx={{ minWidth: 500 }}>
                                <TableHead>
                                    <TableRow>
                                        {tableHeadVcc.map((item, index) => (
                                            <Cell className="pdf-table" key={index}>
                                                {item}
                                            </Cell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {!loader ? (
                                        pdfDataVcc.length > 0 ? (
                                            <Fragment>
                                                {pdfDataVcc.map((item, index) => {

                                                    return (
                                                        <Row
                                                            key={index}
                                                            sx={{ bgcolor: index % 2 !== 0 && "#EFF8E7" }}
                                                        >
                                                            <Cell className="pdf-table">
                                                                {index + 1 ?? "-"}
                                                            </Cell>
                                                            <Cell className="pdf-table" onClick={() => downloadAllAttachments(item?.vcc_document_url)} style={{ cursor: 'pointer', textDecoration: 'underline' }}>

                                                                {item?.vcc_number ?? "-"}
                                                            </Cell>
                                                            <Cell className="pdf-table">
                                                                {item?.vin ?? "-"}

                                                            </Cell>
                                                            <Cell>Bot {item?.bot_number} task - {item?.is_completed === true ? "Completed" : "Pending"}</Cell>
                                                            <Cell>{item?.status ? item?.status : "-"}</Cell>

                                                        </Row>

                                                    );
                                                })}
                                            </Fragment>
                                        ) : (
                                            <Row>
                                                <Cell
                                                    colSpan={tableHeadVcc?.length + 1}
                                                    align="center"
                                                    sx={{ fontWeight: 600 }}
                                                >
                                                    No Data Found
                                                </Cell>
                                            </Row>
                                        )
                                    ) : (
                                        <Row>
                                            <Cell
                                                colSpan={tableHeadVcc?.length + 2}
                                                align="center"
                                                sx={{ fontWeight: 600 }}
                                            >
                                                <Box className={classes.loaderWrap}>
                                                    <CircularProgress />
                                                </Box>
                                            </Cell>
                                        </Row>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </Fragment>


                    <Pagination
                        currentPage={currentPage2}
                        pageSize={pageLimit2}
                        onPageSizeChange={(size) =>
                            getVccData(1, size.target.value)
                        }
                        tableCount={pdfDataVcc?.length}
                        totalCount={totalCount2}
                        onPageChange={(page) => getVccData(page, "")}
                    />


                </Box>
            </Box>
        </>
    );
}
export default UploadDeclaration;
